import React from 'react';
import { User } from '../../../../entities/User';
import {
  ApplicationFeed,
  ApplicationFeedEmail,
} from '../../../../entities/ApplicationFeed';
import { CommentList } from './CommentList';
import { CommentInput } from './CommentInput';
import { SendEmailModal } from '../../../SendEmailModal';
import { Application } from '../../../../entities/Application';
import { CommentButton } from './CommentList/CommentButton';
import { AccountIntegration } from '../../../../entities/AccountIntegration';
import { AlertObject, AlertType } from '../../../../components/Alert';
import { SendEmailDto } from '../../../../services/dtos/EmailDto';
import { ApplicationService } from '../../../../services/applicant_tracking/ApplicationService';
import { ApiError } from '../../../../services/ApiService/errors/ApiError';

interface PropTypes {
  application: Application;
  entry: ApplicationFeed;
  currentUser: User;
  emailAccountIntegration?: AccountIntegration;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function CommentSection(props: PropTypes) {
  const [showNewCommentBox, setShowNewCommentBox] =
    React.useState<boolean>(false);
  const [showReplyToEmail, setShowReplyToEmail] =
    React.useState<boolean>(false);

  const handleNewCommentClose = (state: boolean) => {
    if (state) {
      props.reloadFeed();
    }
    setShowNewCommentBox(false);
  };

  const onSendEmail = async (sendEmailProps: SendEmailDto) => {
    await ApplicationService.sendEmails([props.application.id], sendEmailProps)
      .then(() => {
        props.setAlert({
          message: 'This email was successfully sent.',
          type: AlertType.Success,
        });

        props.reloadFeed();
      })
      .catch((e: ApiError) => {
        props.setAlert({
          message: e.body?.message || 'The email was not sent.',
          type: AlertType.Danger,
        });
      })
      .finally(() => setShowReplyToEmail(false));
  };

  return (
    <>
      {showReplyToEmail && props.emailAccountIntegration && (
        <SendEmailModal
          applicationIds={[props.application.id]}
          toEmail={props.application.candidate.email}
          hasEmailConnected={props.currentUser.hasEmailConnected}
          isOpen={showReplyToEmail}
          onCloseModal={() => setShowReplyToEmail(false)}
          onSendEmail={onSendEmail}
          replyToEmail={(props.entry as ApplicationFeedEmail)?.email}
        />
      )}
      {showNewCommentBox && (
        <div className='mt-3'>
          <CommentInput
            entry={props.entry}
            currentUser={props.currentUser}
            onClose={handleNewCommentClose}
          />
        </div>
      )}
      {props.entry.comments.length > 0 ? (
        <CommentList
          applicationFeed={props.entry}
          currentUser={props.currentUser}
          showNewCommentBox={showNewCommentBox}
          setShowNewCommentBox={setShowNewCommentBox}
          setShowReplyToEmail={setShowReplyToEmail}
          reloadFeed={props.reloadFeed}
          setAlert={props.setAlert}
        />
      ) : (
        <div className='mt-2h'>
          <CommentButton
            showNewCommentBox={showNewCommentBox}
            entryType={props.entry.entryType}
            setShowNewCommentBox={setShowNewCommentBox}
            setShowReplyToEmail={setShowReplyToEmail}
          />
        </div>
      )}
    </>
  );
}
